import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 3,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2
        }}>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            gap: 2 
          }}>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} Dinero Economic. All rights reserved.
            </Typography>
            <Box 
              sx={{ 
                display: { xs: 'none', sm: 'block' },
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                bgcolor: 'text.disabled'
              }} 
            />
            <Typography variant="body2" color="text.secondary">
              Version 1.0.0
            </Typography>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            gap: 3,
            '& a': {
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': {
                color: 'primary.main'
              }
            }
          }}>
            {/* <Link href="#" variant="body2">Privacy Policy</Link>
            <Link href="#" variant="body2">Terms of Service</Link> */}
            <Link href="#" variant="body2">Contact Support</Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 